export default __webpack_public_path__ + "5f71b671a01851f2e274e4c0f98d337e.svg";